<template>
  <div id="screen" class="ui basic container segment" style="overflow:auto">
    <div class="ui purple segment">
      <h3 style="text-align: center">Transporter returns</h3>
      <div class="ui left aligned basic segment">
        <form id="locationform">
          <div class="field">
            <label>Location:</label>
            <select id="locationselector" v-model="selectedlocation" @change="locationChanged" class="ui dropdown">
              <option value="-1"></option>
              <option v-for="(loc,index) in this.$locations" :key="index" :value="loc.id">{{ loc.companyname }}</option>
            </select>
          </div>
        </form>
      </div>
    </div>
    <div class="ui purple segment" v-if="selectedlocation != -1">
      <div class="ui header">Vehicle list ({{ Object.keys(regs).length }} items):</div>
      <button class="ui right floated primary button" :class="{disabled:saving, loading:saving}" @click="saveStocklist" v-if="readyToSave">Save stocklist</button><button class="ui primary button" @click="takePhoto">Add a new plate</button>
      <div id="stocklist" class="ui fluid stackable cards" style="margin-top:1em">
        <div class="card" v-for="(r, index) in Object.keys(regs).reverse()" :key="index" :class="{red:regs[r].reg===''}">
          <div class="image">
            <div style="position: absolute;z-index: 0;width: 100%;">
              <button class="ui right floated mini circular icon button" style="margin-top: 1em;margin-right: 1em;" @click="removeStockItem(r)">
                <i class="close icon"></i>
              </button>
            </div>
            <img :src="regs[r].p">
            <div class="content">
              <form class="ui form"><input type="text" v-model="regs[r].reg" class="ui input" :placeholder="!Object.hasOwn(regs[r],'reg')?'-- not recognised yet --':regs[r].reg==''?'-- unable to recognise':''"></form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="modalcontainer">

    <div class="ui modal" id="photomodal" style="margin:auto;position:static">
      <i class="close icon" @click="closePhotoModal"></i>
      <div class="header">Take a photo</div>
      <div class="image content">
        <div class="ui medium image">
          <video id="myvideo" autoplay="true" muted playsinline="true" style="width:100%;aspect-ratio: 4;object-fit: cover;"></video>
        </div>
        <div class="description">
          <div class="ui header">How to take a photo</div>
          <p>
            Please move your camera to position the number plate to fit in the rectangle on the left side.<br>
            Hold camera still and hit the button below<br><br>When you're done, the system will try to recognise it right away when you are online.
          </p>
          <div style="text-align:center"><button class="ui circular huge primary icon button" id="camerabtn" @click="takePicture"><i class="camera icon"></i></button></div>
          <div class="ui error visibleif message" id="cameraerror">Unable to start video device</div>
        </div>
      </div>
      <div class="actions">
        <button class="ui black deny button" @click="closePhotoModal">
          Cancel
        </button>
      </div>
    </div>

  </div>
</template>

<style>
  /* The Modal (background) */
  #modalcontainer {
    display: none; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 1; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0,0,0); /* Fallback color */
    background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
  }

</style>

<script>
  import { computed } from 'vue';

  function diff (num1, num2) {
    if (num1 > num2) {
      return num1 - num2
    } else {
      return num2 - num1
    }
  }
  
  export default {
    data() {
      return {
        regs:{},
        selectedlocation:-1,
        locations:[],
        cameraError: false,
        videos:null,
        video:null,
        saving:false,
        readyToSave: computed(()=>{
          var i;
          if (Object.keys(this.regs).length===0) return false;

          for (i in this.regs) {
            if (!this.regs[i].reg) return false;
            if (this.regs[i].reg === '') return false;
          }

          return true;
        })
      }
    },
    methods: {
      getLocation() {
        var thiz = this;
        if(navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((event) =>{
              var i,a,o,op=-1,od,nd;
              
              for (i=0; i< thiz.$locations.length; i++) {
                if (!(thiz.$locations[i].lat)) {
                  continue;
                }

                if (op === -1) {
                  op = i;
                  a = diff(event.coords.latitude, thiz.$locations[i].lat);
                  o = diff(event.coords.longitude, thiz.$locations[i].lon);

                  od = a*a+o*o;
                }
                else {
                  a = diff(event.coords.latitude, thiz.$locations[i].lat);
                  o = diff(event.coords.longitude, thiz.$locations[i].lon);
                  nd = a*a+o*o;

                  if (nd < od) {
                    od=nd;
                    op = i;
                  }
                }
              }
              thiz.selectedlocation = thiz.$locations[op].id;

            },(e)=>{
              console.log(e);
            },{enableHighAccuracy:true}
          );
        } else {
            alert("Your browser doesn't support Geolocation");
        }
      },
      removeStockItem(index){
        delete this.regs[index];
      },
      takePicture() {
        var canvas = document.createElement('canvas');
        const context = canvas.getContext("2d");
        canvas.width = this.video.videoWidth;
        canvas.height = this.video.videoWidth/4;

        context.drawImage(this.video, 0, (this.video.videoHeight - (this.video.videoWidth/4))/2, this.video.videoWidth, this.video.videoWidth/4, 0, 0, this.video.videoWidth, this.video.videoWidth/4);
        const data = canvas.toDataURL("image/jpeg");

        var d = {p:data};
        this.regs[Date.now()] = d;
        this.closePhotoModal();
      },
      closePhotoModal() {
        document.querySelector('#modalcontainer').style.display='none';
        document.querySelector('#photomodal').className = 'ui modal';
        if (this.videos) {
          this.videos.getTracks().forEach( (track) => {
            track.stop();
          });

          this.videos = null;
        }
      },
      saveStocklist() {
        this.saving = true;
        var thiz = this, i;

        var dts = {
          location: this.selectedlocation,
          regs: []
        };

        for (i in this.regs) {
          dts.regs.push(this.regs[i].reg);
        }

        fetch(this.$host+'/savetr', {
          method: 'POST',
          headers: {'Content-type':'application/json'},
          credentials:'include',
          mode:'cors',
          body: JSON.stringify(dts)
        }).then(res=>res.json()).then(res=>{
          thiz.saving = false;
          if (res.error) {
            //errorBox('Application error #426', res.error);
          }
          else {
            alert('We have successfully saved your list.');
            thiz.$router.push('/');
            // infoBox('Success','We have successfully saved your list. <a href="/mainmenu.html">go to the main menu</a>');
          }
        }).catch(err=>{
          thiz.saving = false;
          console.log('system error #432', err);
        });
      },
      startCamera() {
        this.cameraError=false;
        var thiz = this;
        var cn;

        document.querySelector('#modalcontainer').style.display='flex';
        cn = document.querySelector('#photomodal').className.split(' ');
        if (cn.indexOf('active') == -1) {
          cn.push('active');
          document.querySelector('#photomodal').className = cn.join(' ');
        }

        navigator.mediaDevices.getUserMedia({
          audio: false,
          video: {
            facingMode: "environment"
          }
        }).then((s) => {
          thiz.video = document.getElementById('myvideo');

          try {
            thiz.video.srcObject = s;
            thiz.videos = s;
          }
          catch(e){
            console.log(e);
            alert(e.toString());
          }
        }).catch(err=>{
          console.log('system error #165', err);
          thiz.cameraError = true;
        });
      },
      takePhoto() {
        this.startCamera();
      },
      locationChanged() {
        console.log('location changed', this.selectedlocation);
      },
      recognisePlates() {
        var i, foundone=false;
        var thiz = this;

        //console.log('recognisePlates');

        if (navigator.onLine) {
          //console.log('recognisePlates online');
          for (i in this.regs) {
            if (Object.hasOwn(this.regs[i], 'reg')) continue;

            fetch(this.$host+'/recognise', {
              method:'POST',
              mode:'cors',
              credentials:'include',
              headers:{'Content-type':'application/json'},
              body:JSON.stringify({img:this.regs[i].p, i:i, location:this.selectedlocation})
            }).then(res=>res.json()).then(res=>{
              if (res.error){
                console.log('application error #274', res);
              }
              else {
                if (res && res.res && res.res.results && res.res.results.length>0) {
                  thiz.regs[res.i].reg = res.res.results[0].plate.toUpperCase();
                }
                else {
                  thiz.regs[res.i].reg = '';
                  //document.querySelectorAll('#stocklist .card input')[res.i].setAttribute('placeholder','-- unable to recognise --')
                  //document.querySelectorAll('#stocklist .card button.circular')[res.i].className = 'ui right floated mini circular icon red button';
                  //document.querySelectorAll('#stocklist .card')[res.i].className = 'red card';
                }

                console.log(thiz.regs[res.i]);
              }

              setTimeout(()=>{thiz.recognisePlates()},1250);
            }).catch(err=>{
              console.log('system error #273', err);
              setTimeout(()=>{thiz.recognisePlates()},5000);
            });
            foundone=true;
            break;
          }

          if (!foundone) setTimeout(()=>{thiz.recognisePlates()},500);
        }
        else {
          //console.log('recognisePlates offline');
          setTimeout(()=>{thiz.recognisePlates()},1000);
        }
      }
    },
    mounted() {
      setTimeout(()=>{
        const e = document.querySelector('#purpleheader').animate({height:"130px"}, 500)
        e.onfinish = ()=>{
          document.querySelector('#purpleheader').style.height = "130px";
        };
      },0);

      this.getLocation();

      this.recognisePlates();
    }
  }
// https://www.youtube.com/watch?v=2mKwCmaR5Qg&t=762s
</script>
